import React from 'react';
import { FormattedMessage } from 'react-intl-next';
import { messages } from '../messages';
import FeedbackCollector from '../../feedback-collector/feedback-collector';
// eslint-disable-next-line @atlaskit/design-system/no-emotion-primitives -- to be migrated to @atlaskit/primitives/compiled – go/akcss
import { Box, xcss } from '@atlaskit/primitives';
import { FeedbackButton } from '@atlassian/search-common';
var footerContainerStyles = xcss({
  paddingTop: 'space.150',
  paddingBottom: 'space.150',
  paddingLeft: 'space.200',
  paddingRight: 'space.200',
  borderTop: '1px solid',
  borderColor: 'color.border',
  display: 'flex',
  alignItems: 'center',
  color: 'color.text',
  gap: 'space.150'
});
export var FeedbackFooter = function FeedbackFooter() {
  return /*#__PURE__*/React.createElement(Box, {
    xcss: footerContainerStyles
  }, /*#__PURE__*/React.createElement(FormattedMessage, messages.quick_find_footer_text), /*#__PURE__*/React.createElement(FeedbackCollector, {
    TriggerComponent: function TriggerComponent(_ref) {
      var onClick = _ref.onClick;
      return /*#__PURE__*/React.createElement(FeedbackButton, {
        onClick: onClick
      });
    }
  }));
};